import { useTranslation } from '@kostbar/i18n'
import type { EdgeKioskConfig } from '@/api/types'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

type KiosksTabProps = {
  kiosks: Array<EdgeKioskConfig>
  onUpdateKiosk: (index: number, patch: Partial<EdgeKioskConfig>) => void
  onAddKiosk: () => void
  onRemoveKiosk: (index: number) => void
}

export function KiosksTab({
  kiosks,
  onUpdateKiosk,
  onAddKiosk,
  onRemoveKiosk,
}: KiosksTabProps) {
  const { t: tRestaurants } = useTranslation('restaurants')

  return (
    <div className="space-y-4">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>
              {tRestaurants('edgeSettings.kiosks.stationId')}
            </TableHead>
            <TableHead>{tRestaurants('edgeSettings.kiosks.name')}</TableHead>
            <TableHead>{tRestaurants('edgeSettings.kiosks.zone')}</TableHead>
            <TableHead className="text-right"></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {kiosks.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className="text-muted-foreground">
                {tRestaurants('edgeSettings.kiosks.empty')}
              </TableCell>
            </TableRow>
          ) : (
            kiosks.map((kiosk, index) => (
              <TableRow key={`${kiosk.stationId || 'kiosk'}-${index}`}>
                <TableCell>
                  <Input
                    value={kiosk.stationId}
                    onChange={(e) =>
                      onUpdateKiosk(index, { stationId: e.target.value })
                    }
                  />
                </TableCell>
                <TableCell>
                  <Input
                    value={kiosk.name || ''}
                    onChange={(e) =>
                      onUpdateKiosk(index, { name: e.target.value })
                    }
                  />
                </TableCell>
                <TableCell>
                  <Input
                    value={kiosk.zone}
                    onChange={(e) =>
                      onUpdateKiosk(index, { zone: e.target.value })
                    }
                  />
                </TableCell>
                <TableCell className="text-right">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onRemoveKiosk(index)}
                  >
                    {tRestaurants('edgeSettings.kiosks.remove')}
                  </Button>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      <Button variant="outline" onClick={onAddKiosk}>
        {tRestaurants('edgeSettings.kiosks.add')}
      </Button>
    </div>
  )
}
